const timeStamp = () => {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}_${pad(d.getHours())}-${pad(d.getMinutes())}-${pad(d.getSeconds())}`;
};

export const usePhotoShare = ({ url, fileName }: { url: string | null | undefined, fileName?: string | null | undefined }) => {
  const savePhoto = () => {
    if (!url) return;
    fetch(url).then(res => {
      res.blob().then(async blob => {
        // allow user to select location if showSaveFilePicker is available (chrome/edge)
        if ('showSaveFilePicker' in window) {
          // @ts-ignore
          const handle = await window.showSaveFilePicker({ suggestedName: fileName ? fileName : `INVISION Field Visit Image ${timeStamp()}` });
          const w = await handle.createWritable();

          await w.write(blob);
          await w.close();

          return;
        }

        // try share menu (safari, firefox)
        const file = new File([blob], 'image.png', { type: 'image/png' });
        if (!!navigator?.canShare && navigator.canShare({ files: [file] })) {
          navigator.share({
            files: [file],
            title:fileName ? fileName : `INVISION Field Visit Image ${timeStamp()}`
          });

          return;
        }

        // fallback to browser download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName ? fileName : `INVISION Field Visit Image ${timeStamp()}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(link.href);
      });
    });
  };

  return {
    savePhoto
  };
};
